import {
  ADD_ZONE_FORM,
  CLEAR_ZONE_FORM,
  FORM_CLEAR,
  FORM_UPDATE
} from "./actionTypes";

export const updateForm = (data) => ({
  type: FORM_UPDATE,
  payload: { data },
});

export const clearForm = () => ({
  type: FORM_CLEAR,
});

export const addZoneForm = (zone) => ({
  type: ADD_ZONE_FORM,
  payload: { zone },
});

export const clearZoneForm = () => ({
  type: CLEAR_ZONE_FORM,
});

export const updateUsersData = (data) => (dispatch) => {
  dispatch({ type: "UPDATE_USERS_DATA", payload: data });
};